import { Controller } from "@hotwired/stimulus";

/**
 * Student file sharing table (Dossier élève, 08/10/2026): one column per
 * school. « Tout » / « Aucun » tick or untick a school's column, « Tout
 * sélectionner » / « Tout désélectionner » the whole table. Nothing is saved
 * until « Enregistrer le partage ».
 *
 * <div data-controller="sharing-matrix">
 *   <button data-action="sharing-matrix#column" data-school="12" data-checked="true">
 *   <input type="checkbox" data-sharing-matrix-target="box" data-school="12">
 */
export default class extends Controller {
  static targets = ["box"];

  column(event) {
    const { school, checked } = event.currentTarget.dataset;
    this.#set((box) => box.dataset.school === school, checked === "true");
  }

  selectAll() {
    this.#set(() => true, true);
  }

  deselectAll() {
    this.#set(() => true, false);
  }

  #set(match, checked) {
    this.boxTargets.filter((box) => !box.disabled && match(box)).forEach((box) => {
      box.checked = checked;
    });
  }
}
